import styled from "styled-components"
import SylhetBanner from "../blocks/SylhetBanner"
import SylhetSituation from "../blocks/SylhetSituation"
import ReliefProgram from "../blocks/ReliefProgram"
import CallToAction from "../blocks/CallToAction"
import Footer from "../blocks/Footer"

const StyledSylhetRelief = styled.div`
  background-color: var(--gray-50);
  color: var(--gray-800);
  font-family: 'Gilroy', sans-serif;
`

const FooterContainer = styled.div`
  background-color: var(--dark-green);
`

const SylhetReliefLanding = () => {
  return (
    <StyledSylhetRelief>
      <SylhetBanner/>
      <SylhetSituation/>
      <ReliefProgram/>
      <CallToAction/>
      <FooterContainer>
        <Footer/>
      </FooterContainer>
    </StyledSylhetRelief>
  )
}

export default SylhetReliefLanding